import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "composer/Localization.jsx"

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, TextField, Grid } from '@material-ui/core';

class ChangePasswordDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      oldPassword:"",
      newPassword:"",
      confirmPassword:""
    };
    autoBind(this);
  }

  updatePassword() {
    if (this.validateInput()) {
      let requestObj = {
        "user_id": this.props.root.getMyUserId(),
        "old_password": this.state.oldPassword.trim(),
        "new_password": this.state.newPassword.trim(),
      }
      this.props.root.refs.API.request("user_update_password", requestObj, this.updatePasswordOK, this.updatePasswordFail);
    }
  }

  updatePasswordOK(res) {
    if (res.body['result'] > 0) {
      this.handleClose();
      this.props.root.addNotification(Localization.strings.PASSWORD_UPDATED);
    }
    else {
      this.props.root.addNotification(Localization.strings.OLD_PASSWORD_NOT_CORRECT);
      this.setState({
        oldPassword: "",
      })
      this.state.oldPassword = "";
    }
  }

  updatePasswordFail(err) {
    console.log("update password failed");
  }

  handleClose() {
    this.setState({
      open: false
    });
    this.state.open = false;
  }

  oldPasswordChanged(event) {
    this.setState({
      oldPassword: event.target.value
    });
    this.state.oldPassword = event.target.value;
  }

  newPasswordChanged(event) {
    this.setState({
      newPassword: event.target.value
    });
    this.state.newPassword = event.target.value;
  }

  confirmPasswordChanged(event) {
    this.setState({
      confirmPassword: event.target.value
    });
    this.state.confirmPassword = event.target.value;
  }

  validateInput() {
    let result = true;
    let password = this.state.newPassword.trim();
    let illegalChars = /[\W_]/;
    let errorMessage = "";

    if (this.state.newPassword.trim() != this.state.confirmPassword.trim()) {
      result = false;
      errorMessage = Localization.strings.PASSWORD_REQUIREMENT_0;
    }
    else if (illegalChars.test(password)) {
      result = false;
      errorMessage = Localization.strings.PASSWORD_REQUIREMENT_1;
    }
    else if (password.search(/[a-zA-Z]+/) == -1 || password.search(/[0-9]+/) == -1) {
      result = false
      errorMessage = Localization.strings.PASSWORD_REQUIREMENT_2;
    }
    else if (password.length < 6) {
      result = false;
      errorMessage = Localization.strings.PASSWORD_REQUIREMENT_3;
    }
    else if (password.length > 30) {
      result = false;
      errorMessage = Localization.strings.PASSWORD_REQUIREMENT_4;
    }
    else if (this.state.oldPassword.trim() == "" || this.state.newPassword.trim() == "" || this.state.confirmPassword.trim() == "") {
      result = false;
      errorMessage = Localization.strings.PASSWORD_REQUIREMENT_5;
    }

    if (errorMessage != "") {
      this.props.root.addNotification(errorMessage);
    }

    return result;
  }

  render() {
      return (
        <div>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
          >
            <DialogTitle>{Localization.strings.CHANGE_PASSWORD}</DialogTitle>
            <DialogContent>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={4}>
                  {Localization.strings.OLD_PASSWORD}
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField
                    helperText="Your original password"
                    onChange={this.oldPasswordChanged}
                    type="password"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  {Localization.strings.NEW_PASSWORD}
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField
                    helperText="New password should contain both letters and numbers"
                    onChange={this.newPasswordChanged}
                    type="password"
                  >
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {Localization.strings.RE_ENTER_NEW_PASSWORD}
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField
                    helperText="Re-enter the new password"
                    onChange={this.confirmPasswordChanged}
                    type="password"
                  >
                  </TextField>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions style={{padding:'16px 24px'}}>
              <Button onClick={this.handleClose}>
                {Localization.strings.CANCEL}
              </Button>
              <Button color="primary" onClick={this.updatePassword} variant="contained">
                {Localization.strings.UPDATE_PASSWORD}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )
  }
}

export default ChangePasswordDialog;
